<template>
    <veui-dialog
        ui="auto"
        :title="title"
        :open="show"
        :footless="true"
        overlay-class="upload-dialog"
        @cancel="close"
    >
        <div class="content">
            <fileUpload
                :type="type"
                @addCase="addCase"
                @addQa="addQa"
            />
        </div>
    </veui-dialog>
</template>

<script>

/**
 * @file
 * @desc 案例上传弹窗
 * @author dingzhenyue@baidu.com
 */

import {Dialog} from 'veui';
import fileUpload from './fileUpload.vue';
export default {
    name: 'upload-dialog',
    components: {
        'veui-dialog': Dialog,
        fileUpload
    },
    props: {
        // 上传类型：案例还是语料，不传默认都包含
        type: {
            type: String,
            default: ''
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
        };
    },
    computed: {
        title() {
            if (!this.type) {
                return '添加内容';
            }
            return this.type === 'case' ? '添加案例' : '添加语料';
        }
    },
    methods: {
        close() {
            this.$emit('closeUploadDialog');
        },
        addCase() {
            this.$emit('addCase');
        },
        addQa() {
            this.$emit('addQa', {isOpenOldEdit: true});
        }
    }
};
</script>

<style lang='less' scoped>
.upload-dialog {
    /deep/ .veui-dialog-content {
        border-radius: 8px;
    }

    .content {
        margin-top: 12px;
        width: 718px;

        /deep/.upload-steps {
            padding: 86px 0 !important;
        }
    }

    .footer {
        .btn {
            width: 115px;
            height: 40px;
            border-radius: 4px;
        }

        .cancel {
            background: #fff;
            border: 1px solid #05f;
            color: #05f;
            margin-left: 20px;
        }
    }
}
</style>
